const IconCross = ({className = ''}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50.65 50.65"
  className={className}
    >
    <g id="Layer_2" data-name="Layer 2">
      <g
        id="Layer_1-2"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="4"
        data-name="Layer 1"
      >
        <path d="M25.33 2v46.65M48.65 25.33H2"></path>
      </g>
    </g>
  </svg>
);

export default IconCross;